import React from 'react';

const Title = ({ text }) => {
    return (
        <h1 className="text-4xl font-['Montserrat'] uppercase text-[#06caff] [text-shadow:_1px_1px_5px_rgb(131_232_255_/_60%)]">
            { text }
        </h1>
    )
} 

export default Title;